/**
 * @generated SignedSource<<b540750eff44dcd565c3a5d088b072e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsPlusInlinePaywall$data = {
  readonly contentLock: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle" | "helpersGetArticleTypeArticle">;
  readonly " $fragmentType": "helpersIsPlusInlinePaywall";
};
export type helpersIsPlusInlinePaywall$key = {
  readonly " $data"?: helpersIsPlusInlinePaywall$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsPlusInlinePaywall">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsPlusInlinePaywall"
};

(node as any).hash = "438eb47e0187e0616fa46050b7007fda";

export default node;
